// Wishlist Prime updates .iwish-counter itself. Match the cart badge by hiding
// zero counts, including when the app restores a saved list after page load.
if (!customElements.get('wishlist-count')) {
  customElements.define('wishlist-count', class extends HTMLElement {
    connectedCallback() {
      this.observer ??= new MutationObserver(() => this.updateCount());
      this.observer.observe(this, { childList: true, characterData: true, subtree: true });
      this.updateCount();
    }

    disconnectedCallback() {
      this.observer.disconnect();
    }

    updateCount() {
      this.classList.toggle('opacity-0', !(Number(this.textContent.trim()) > 0));
    }
  });
}
